var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
let JackpotPopupButton = class JackpotPopupButton extends React.Component {
    render() {
        let { buttonName, buttonLink, inputRef, isSticky, showBottomLinkBtn } = this.props;
        return (React.createElement("div", { className: `rj-jackpot-popup-message__link-wrapper ${this.getBottomClass(isSticky, showBottomLinkBtn)}` },
            React.createElement("a", { href: buttonLink, ref: inputRef, className: "rj-jackpot-popup-message__link" }, buttonName)));
    }
    getBottomClass(isSticky, showBottomLinkBtn) {
        return isSticky ? showBottomLinkBtn ? "rj-jackpot-popup-message__link-wrapper--sticky" : "isHidden" : "";
    }
};
JackpotPopupButton = __decorate([
    observer
], JackpotPopupButton);
export { JackpotPopupButton };
//# sourceMappingURL=JackpotPopupButton.js.map